import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

import { AllPostJobsComp } from "../../components/allPostjobs";
import { AppDispatch, RootState } from "../../store";
import {
  decreasePage,
  getAllPostJobs,
  increasePage,
  jobsPerPage,
} from "../../features/postJob/getAllPostJobsSlice";
import { Pagination } from "../../components/General/helpers";
import { addQueryParams } from "../../utils/queryParams";
import StatCardSkeleton from "../../components/Skeletons/StatCardSkeleton";

const AllPostJobs = () => {
  const { currentPage, pageSize, totalPages, postJobsLoading, allPostJobs } =
    useSelector((store: RootState) => store.allPostJobsStore);

  const [isJobPage, setIsJobPage] = useState(false);

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  //
  const handleSaveForLater = () => {
    //
  };

  // Navigate to single job page
  const handleJobDetails = (index: string) => {
    // console.log(index);
    navigate(`/all-post-jobs/${index}`);
  };

  // Go to next page
  const handleNextButton = () => {
    dispatch(increasePage());
  };

  // Go to previous page
  const handlePreviousButton = () => {
    dispatch(decreasePage());
  };

  // Set the number of jobs to see per page
  const handleClickPage = (value: number) => {
    // console.log(value);
    dispatch(jobsPerPage(value));
    setIsJobPage(false);
  };

  // INCLUDE THE URL WITH THE LIMIT AND PAGE NUMBERS
  useEffect(() => {
    addQueryParams(pathname, currentPage, pageSize);
  }, [pathname, currentPage, pageSize]);

  //   Fetch all post jobs
  useEffect(() => {
    dispatch(getAllPostJobs({ isEngineering: false, currentPage, pageSize })); // Fetch all post jobs
  }, [currentPage, pageSize, dispatch]);

  if (postJobsLoading) {
    return <StatCardSkeleton />;
  }

  if (allPostJobs?.length < 1) {
    return (
      <NoJobsWrapper>
        <p className="no__job">NO JOBS YET</p>
      </NoJobsWrapper>
    );
  }

  return (
    <PostJobsWrapper>
      <AllPostJobsComp
        handleJobDetails={handleJobDetails}
        handleSaveForLater={handleSaveForLater}
      />

      <Pagination
        handlePreviousButton={handlePreviousButton}
        handleNextButton={handleNextButton}
        handleClickPage={handleClickPage}
        isJobPage={isJobPage}
        setIsJobPage={setIsJobPage}
        currentPage={currentPage}
        pageSize={pageSize}
        totalPages={totalPages}
      />
    </PostJobsWrapper>
  );
};

export default AllPostJobs;

const PostJobsWrapper = styled.div`
  /* border: 2px solid red; */
  max-width: 1400px;
  margin: 2rem auto;
  /* padding-inline: 1rem; */
`;

const NoJobsWrapper = styled.div`
  .no__job {
    font-size: 24px;
    font-weight: bold;
  }
`;
